import React, { useEffect, useState } from 'react';
import { Formik, Field, Form, ErrorMessage} from 'formik';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Navbar from './Navbar';
import { Auth } from '@aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';

const QueryExportForm = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [recordCount, setRecordCount] = useState('');
    const [presignedUrl, setPresignedUrl] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [link, setLink] = useState('');
    const[linkText, setLinkText] = useState('');
    const [idToken, setIdToken] = useState('');
    const navigate = useNavigate();
  
    useEffect(() => {
        checkLogin();
    }, []);

    async function checkLogin() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            setIdToken(user.signInUserSession.idToken.jwtToken);
            setIsLoggedIn(true);
            
         } catch {
            console.log('in queryexportform: User not signed in');
            setIsLoggedIn(false);
            navigate('/login');
        }
    }
  
  
    useEffect(() => {
        
        if (isLoggedIn){
            console.log('Logged in');
            setLink('/logout');
            setLinkText('Logout');    
        }else{
            console.log('Not logged in');
            setLink('/login');
            setLinkText('Login');   

        }
    }, [isLoggedIn]);


    const handleSubmit = (values, {resetForm}) => {
        
        console.log('in handleSubmit');
        setIsLoading(true);

        setPresignedUrl('');
        setCsvData([]);
        let { start_date, end_date, export_records,  } = values;

        let date = new Date(start_date);
        date.setHours(date.getHours()+8);
        const formattedStartDate = date.toISOString().slice(0, 10);

        date = new Date(end_date);
        date.setHours(date.getHours()+8);
        const formattedEndDate = date.toISOString().slice(0, 10);
        console.log(formattedStartDate);
        console.log(formattedEndDate);
        console.log(export_records);
        

        if (export_records) {
            export_records = "true";
        }else{
            export_records = "false";
        }

        const payload = {
          
            start_date: formattedStartDate,
            end_date: formattedEndDate,
            export: export_records,
        };
        
        const apiUrl = 'https://1qk0vhgbua.execute-api.ap-southeast-1.amazonaws.com/prod/query';

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key':'70pP5oMTgE9IlNLym0zGN8YTNamYIr4U7xxOy4Jq',
                'Authorization': 'Bearer ' + idToken
            },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
            setCsvData(data);
            if (data.record_count>1){
                setRecordCount(data.record_count + ' records retrieved');
            }
            else{
                setRecordCount(data.record_count + ' record retrieved');
            }

            if (export_records == "true"){
                const presigned_url = data.presigned_url;
                setPresignedUrl(presigned_url);
            }

            setIsLoading(false);
        })
        .catch((error) => {
            console.error('Error:', error);
            setIsLoading(false);
        });

    };

    const DataTable = ({ data }) => {
        return (
          <table className="csvTable"> 
            <thead>
              <tr>
                <th>UID</th>
                <th>CR Card Number</th>
                <th>Email</th>
                <th>Pass Number</th>
                <th>Pass Expiry</th>
                <th>Zones</th>
                <th>Company Name</th>
                <th>Corporate Email</th>
                <th>Aircrew</th>
                <th>Landside</th>
                <th>Completed Training</th>
                <th>Primary Area</th>
                <th>Signup Source</th>
                <th>Staff Group</th>
                <th>Exception</th>
                <th>Created Date</th>
             
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                
                <tr key={index}>
                  <td>{item.uid}</td>
                  <td>{item.cr_card_number}</td>
                  <td>{item.email}</td>
                  <td>{item.pass_number}</td>
                  <td>{item.pass_expiry}</td>
                  <td>{item.zones}</td>
                  <td>{item.company_name}</td>
                  <td>{item.corporate_email}</td>
                  <td>{item.aircrew}</td>
                  <td>{item.landside}</td>
                  <td>{item.completed_training}</td>
                  <td>{item.primary_area}</td>
                  <td>{item.signup_source}</td>
                  <td>{item.staff_group}</td>
                  <td>{item.exception}</td>
                  <td>{item.created_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      }
      

    return (
        <Formik
            initialValues={{
                start_date: '',
                end_date: '',
                export: false,
            }}
            onSubmit={handleSubmit}
            //validationSchema={QueryExportSchema}
       
        >
                

        {({ setFieldValue, values, resetForm }) => (
        <Form>

        <div className="flex-container-1">         
            <div className="upload-container">
                <Navbar link={link} linkText={linkText}/>
                {/*}
                    <a className="loginout-button-style" href={link}>{linkText}</a> 
                */}
     
                <div className="upload-contents-container">

                    <div className="upload-text-container">
                        <i className="fa-solid fa-cloud-arrow-down fa-2xl"></i><h2>Query/Export</h2>
                            <p>Query for start and end dates and optionally export matching records</p>
                        </div>
                        <div className="upload-text-container">
                        
                            <label>Start Date</label>
                            <div>
                                <DatePicker 
                                    selected={values.start_date}
                                    onChange={date => setFieldValue('start_date', date)}
                                    dateFormat="yyyy-MM-dd"
                                />
                        
                                <ErrorMessage name="start_date" component="div" className="error-message"/>
                            </div>
                        </div>

                        <div className="upload-text-container">
                            <label>End Date</label>
                            <div>
                                <DatePicker 
                                    selected={values.end_date}
                                    onChange={date => setFieldValue('end_date', date)}
                                    dateFormat="yyyy-MM-dd"
                                />
                                <ErrorMessage name="end_date" component="div" className="error-message"/>
                            </div>    
                        </div>

                        <div className="upload-text-container">
                            <div className="checkbox-container-3">
                                <Field className="large-checkbox-2" type="checkbox" name="export_records" />Export Records
                            </div>
                        </div>

                        <div>
                                {isLoading && (
                                    <div className="spinner">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                )}
                        </div>

                        <div className="upload-text-container">
                            <div className="button-container">
                                <button className="upload-button" type="submit">Export to CSV</button>
                            </div>
                        </div>

                        {presignedUrl && (
                            <div className="upload-text-container">
                                <a href={presignedUrl}>Link to exported file</a>
                            </div>
                        )}
            
                        <div className="upload-text-container"></div>
                            <div className="csvtable-scrollable-div">

                                    <label>{recordCount}</label>
                            
                                {csvData && csvData.items && <DataTable data={csvData.items} />}              
                            </div>
                        </div>
                    </div>
                           
                </div>
          </Form>
        )}
        </Formik>
    );
};

export default QueryExportForm;
